import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Table
} from 'reactstrap';

import $ from "jquery";
var JSONViewer = require('react-json-viewer');
import ReactJson from 'react-json-view'
const v = require('voca');
import { makeInput } from "common-import/custom";
import { MobXHelper, Request, VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";

@inject("cartOrderStore", "userStore") @observer
class OrderDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      project: {},
      status: ''
    }
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    this.getOrderDetail();
  }

  deleteOrder = async () => {
    const { cartOrderStore, match } = this.props;
    const shouldDelete = confirm('Are you sure to delete order: ' + match.params.id);
    if (!shouldDelete) return;

    const res = await cartOrderStore.deleteOrder(match.params.id);
    if (!!res.error) return window.toast.error('An error occur, ' + JSON.stringify(res.error));
    window.toast.info('Order Deleted');
    setTimeout(() => {
      this.props.history.push("/orders/waiting");
    }, 1000);
  }

  getOrderDetail = async () => {
    const { cartOrderStore, match } = this.props;
    console.log('ID', match.params.id)
    await cartOrderStore.setCurrentOrder(match.params.id);
    this.setState({
      status: cartOrderStore.currentOrder.status,
    });
    // let project = await cartOrderStore.getProjectDetail(match.params.id);
    // this.setState({ project });
  }

  approveOrder = async e => {
    e.preventDefault();
    const { status } = this.state;
    const { cartOrderStore, match } = this.props;
    let continueApprove = confirm(`Bạn có chắc chắn muốn xác thực đơn hàng này với trạng thái: ${status}?`);
    if (continueApprove) {
      // alert("Chức năng xác thực đang hoàn thiện");
      let result = await cartOrderStore.approve({ id: match.params.id, status });
      if (!!result.error) return window.toast.error("Có lỗi xảy ra, vui lòng thử lại   " + JSON.stringify(result.error));
      window.toast.info("Duyệt đơn hàng thành công");
      // this.setState({ contractor: { ...this.state.contractor, approved: 1 } })
      cartOrderStore.currentOrder = { ...cartOrderStore.currentOrder, status: status };
    }
  }

  renderApprove = () => {
    const { cartOrderStore, match } = this.props;
    const { currentOrder } = cartOrderStore;
    const { status } = currentOrder;
    // if (status === undefined || status === "" || status === true || status === 1 || status === "COMPLETED") return null;
    return (
      <Row style={{ marginBottom: 30 }}>
        <Col xs="12" md="12" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          
          <Input type="select" name="ccmonth" id="ccmonth" style={{ height: 35 }} value={this.state.status} onChange={(e) => this.setState({ status: e.target.value })}>
            <option value="">Đơn này đang cần duyệt</option>
            {/* <option value="">Đơn này đang đang trong trạng thái: ({status})</option> */}
            <option value="WAITING">Chờ thanh toán (WAITING)</option>
            <option value="COMPLETED">Hoàn thành (COMPLETED)</option>
            <option value="SHIPPED_ORDERS">Đã Ship (SHIPPED_ORDERS)</option>
            <option value="ORDER_IN_PROCESS">Đang tiến hành (ORDER_IN_PROCESS)</option>
            <option value="FAIL_TO_CHARGE">Thanhh toán lỗi (FAIL_TO_CHARGE)</option>
            <option value="CANCELED_ORDERS">Hủy (CANCELED_ORDERS)</option>
          </Input>
          <Button style={{ display: "inline-block", height: 35, borderRadius: 4 }} type="submit" size="sm" color="primary" onClick={this.approveOrder}><i className="fa fa-dot-circle-o"></i> Duyệt</Button>
          
        </Col>
      </Row>
    )
  }

  render() {
    const { cartOrderStore, match } = this.props;
    let { currentOrder } = cartOrderStore;
    const total = (() => {
      if (currentOrder.cart == undefined) return 0;
      let value = 0;
      currentOrder.cart.slice().forEach((item, i) => {
        value = value + item.product.price * item.amount;
      });
      return value;
    })();
    console.log(currentOrder)
    return (
      <div className="animated fadeIn">
        {this.renderApprove()}

        <Row>
          <Col xs="12" md="12">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i>Tóm tắt
              </CardHeader>
              <CardBody>

                <Row>
                  <Col xs="12" md="12" >
                    <p>Tổng số tiền: <strong style={{ color: 'red', fontSize: 16 }}>{VarHelper.moneyString(total)} VND</strong></p>
                    <p>Mặt hàng</p>
                    <div>
                      {!!currentOrder.cart && currentOrder.cart.slice().map((val, index) => (
                        <Row key={"row" + index}>
                          <Col xs="12" md="4" >
                            <p>Tên: <b>{val.product.name}</b></p>
                            <p>Đơn giá: <b>{val.product.price}</b></p>
                          </Col>
                          <Col xs="12" md="4" >
                            <p>Số lượng: <b>{val.amount}</b></p>
                            <p>Thành tiền: <b>{val.amount * val.product.price}</b></p>
                          </Col>
                          <Col xs="12" md="4" ><img width="100%" src={VarHelper.img(val.product.images[0])} /></Col>
                        </Row>
                      ))}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" md="12" >
                    <p>Order này được tạo bởi user: <Link to={`/user/${currentOrder.userId}`}><strong>{currentOrder.userId}</strong></Link></p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>


        <Row>
          <Col xs="12" md="12">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i>Thông tin của order: <strong>{currentOrder.id}</strong> (dữ liệu thô)
              </CardHeader>
              <CardBody>
                {/* <textarea onChange={()=>{}} value={JSON.stringify(currentProject, undefined, 4)} readOnly style={{height: 200, width: '100%', overflow: 'auto'}} /> */}

                <Row>
                  <Col xs="12" md="12" >
                    {/* <div style={{overflowX:'auto'}}>
                      <JSONViewer json={currentProject} />
                    </div> */}
                    <ReactJson
                      src={currentOrder}
                      name={currentOrder.id}
                      displayDataTypes={false}
                      theme={"ocean"}
                    />
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                {/* <Button type="submit" size="sm" color="primary" onClick={this.editProfile}><i className="fa fa-dot-circle-o"></i> Save</Button> */}
                {/* <Button type="reset" size="sm" color="danger" onClick={this.deleteOrder}><i className="fa fa-ban"></i> Xóa đơn</Button> */}
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default OrderDetail;


// WEBPACK FOOTER //
// ./src/views/Shop/OrderDetail.js